<template>
  <div id="patient-information-allergies">
    <h3 class="grey--text text--darken-3 mt-10">Patient Past Medical History</h3>

    <h4 v-show="patient.gender.toLowerCase() == 'female'">
      <p><span style="color: red;">Note: </span>Select on each segment of the date following the format <i>MM/DD/YYYY</i> then press <span style="color: red;">UP</span> or <span style="color: red;">DOWN</span> arrow to change it</p>

      <small><p>For patients that are menopaused or who have undergone surgery, just click on <span style="color: red;">Not Applicable</span> to set it at its default value</p></small>
      <span style="color: #258bf5;">Last Menstrual Period: </span> <input style="border: 1px solid #000; border-radius: 10px; padding: 5px; text-align: center;" type="date" v-model="last_menstrual_period" />
      <button style="background-color: #258bf5 !important; border-color: #258bf5 !important; color: #fff; padding: 5px 25px; border-radius: 15px; display: inline-block; margin: 0px 15px;" class="btn-small btn-danger btn" @click="last_menstrual_period = '1970-01-01'">Not Applicable</button>
      <p>&nbsp;</p>
      <hr />
    </h4>

    <p>&nbsp;</p>

    <v-row>
       <!-- illness/injury input -->
      <v-col cols="6" sm="4">

        <span v-show="illnesses_alert_message" class="alert">{{ illnesses_alert_message }}</span>

        <v-textarea
          v-model="illnesses"
          placeholder=" "
          class="primary-label"
          label="Illness⁄Injury/Current Medication"
          rows="3"
          v-on:focus="() => {this.$vtt.startSpeechListener((text) => {this.illnesses = `${this.illnesses || ''} ${text}`;}, 'illnesses')}"
          v-on:click="() => {this.$vtt.setModel('illnesses');}"
          @input="setHint(illnesses, (replacement) => { illnesses = replacement })"
          @keydown.tab="(e) => {
            if (!getReplacement(illnesses)) { return true; } else { e.preventDefault(); illnesses = getReplacement(illnesses); clearReplacement(); }
          }"
        >
        </v-textarea>
      </v-col>
      
      <!-- hospitalizations input -->
      <v-col cols="6" sm="4">

        <span v-show="hospitalizations_alert_message" class="alert">{{ hospitalizations_alert_message }}</span>

        <v-textarea
          v-model="hospitalizations"
          placeholder=" "
          class="primary-label"
          label="Hospitalizations"
          rows="3"
          v-on:focus="() => {this.$vtt.startSpeechListener((text) => {this.hospitalizations = `${this.hospitalizations || ''} ${text}`;}, 'hospitalizations')}"
          v-on:click="() => {this.$vtt.setModel('hospitalizations');}"
          @input="setHint(hospitalizations, (replacement) => { hospitalizations = replacement })"
          @keydown.tab="(e) => {
            if (!getReplacement(hospitalizations)) { return true; } else { e.preventDefault(); hospitalizations = getReplacement(hospitalizations); clearReplacement(); }
          }"
        >
        </v-textarea>
      </v-col>
      
      <!-- operations input -->
      <v-col cols="6" sm="4">

        <span v-show="operations_alert_message" class="alert">{{ operations_alert_message }}</span>

        <v-textarea
          v-model="operations"
          label="Operations"
          class="primary-label"
          placeholder=" "
          rows="3"
          v-on:focus="() => {this.$vtt.startSpeechListener((text) => {this.operations = `${this.operations || ''} ${text}`;}, 'operations')}"
          v-on:click="() => {this.$vtt.setModel('operations');}"
          @input="setHint(operations, (replacement) => { operations = replacement })"
          @keydown.tab="(e) => {
            if (!getReplacement(operations)) { return true; } else { e.preventDefault(); operations = getReplacement(operations); clearReplacement(); }
          }"
        ></v-textarea>
      </v-col>


      <!-- social factors input -->
      <v-col cols="6" sm="4">

        <span v-show="vices_alert_message" class="alert">{{ vices_alert_message }}</span>

        <v-textarea
          v-model="vices"
          placeholder=" "
          class="primary-label"
          label="Relevant Social Factor"
          rows="3"
          v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.vices = `${this.vices || ''} ${text}`;}, 'vices')}"
          v-on:click="() => {this.$vtt.setModel('vices');}"
          @input="setHint(vices, (replacement) => { vices = replacement })"
          @keydown.tab="(e) => {
            if (!getReplacement(vices)) { return true; } else { e.preventDefault(); vices = getReplacement(vices); clearReplacement(); }
          }"
        >
        </v-textarea>
      </v-col>
      
      <!-- dietary status input -->
      <v-col cols="6" sm="4">

        <span v-show="dietary_alert_message" class="alert">{{ dietary_alert_message }}</span>

        <v-textarea
          v-model="dietary"
          placeholder=" "
          class="primary-label"
          label="Dietary Status"
          rows="3"
          v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.dietary = `${this.dietary || ''} ${text}`;}, 'dietary')}"
          v-on:click="() => {this.$vtt.setModel('dietary');}"
          @input="setHint(dietary, (replacement) => { dietary = replacement })"
          @keydown.tab="(e) => {
            if (!getReplacement(dietary)) { return true; } else { e.preventDefault(); dietary = getReplacement(dietary); clearReplacement(); }
          }"
        >
        </v-textarea>
      </v-col>
      
      <!-- immunization input -->
      <v-col cols="6" sm="4">

        <span v-show="immunization_alert_message" class="alert">{{ immunization_alert_message }}</span>

        <v-textarea
          v-model="immunization"
          placeholder=" "
          class="primary-label"
          label="Immunization"
          rows="3"
          v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.immunization = `${this.immunization || ''} ${text}`;}, 'immunization')}"
          v-on:click="() => {this.$vtt.setModel('immunization');}"
          @input="setHint(immunization, (replacement) => { immunization = replacement })"
          @keydown.tab="(e) => {
            if (!getReplacement(immunization)) { return true; } else { e.preventDefault(); immunization = getReplacement(immunization); clearReplacement(); }
          }"
        >
        </v-textarea>
      </v-col>


      <!-- immunization input -->



      <v-col cols="6" sm="4">

        <v-textarea
          v-model="height"
          placeholder=" "
          class="primary-label"
          label="Height (Centimeters)"
          rows="3"
          v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.height = `${this.height || ''} ${text}`;}, 'height')}"
          v-on:click="() => {this.$vtt.setModel('height');}"
          @input="setHint(height, (replacement) => { height = replacement })"
          @keydown.tab="(e) => {
            if (!getReplacement(height)) { return true; } else { e.preventDefault(); height = getReplacement(height); clearReplacement(); }
          }"
        >
        </v-textarea>
      </v-col>

      <v-col cols="6" sm="4">

        <v-textarea
          v-model="weight"
          placeholder=" "
          class="primary-label"
          label="Weight (Kilograms)"
          rows="3"
          v-on:focus="() => {this.$vtt.startSpeechListener((text) => {this.weight = `${this.weight || ''} ${text}`;}, 'weight')}"
          v-on:click="() => {this.$vtt.setModel('weight');}"
          @input="setHint(weight, (replacement) => { weight = replacement })"
          @keydown.tab="(e) => {
            if (!getReplacement(weight)) { return true; } else { e.preventDefault(); weight = getReplacement(weight); clearReplacement(); }
          }"
        >
        </v-textarea>
      </v-col>

   </v-row>

    
    <p>&nbsp;</p>

    <FamilyHistory ref="familyHistoryForm" :relatives="family_history"></FamilyHistory>
    
    <hr />
    <p>&nbsp;</p>
    <br>

    <patient-allergy></patient-allergy>

    <p>&nbsp;</p>
    <hr />

    <v-row>
      <v-col cols="12" class="pt-10">
        <h3>Seasonal Illness</h3>
        <v-row>
          <v-col cols="5">
            <input type="radio" v-model="isSeasonalIllness" value="1"> Yes | <input type="radio" v-model="isSeasonalIllness" value="0"> No
          </v-col>
          <v-col cols="3">
          </v-col>

        </v-row>
      </v-col>
    </v-row>

    <p>&nbsp;</p>
    <hr />

  </div>
</template>

<script>
  import textreplacementmixin from '../../../../../mixins/textreplacementmixin';
  export default {
    name: "PatientInfo",

    mixins: [textreplacementmixin],

    components: {
      PatientAllergy: () => import('./PatientAllergy.vue'),
      FamilyHistory: () => import("../form/FamilyHistory.vue"),
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    data: () => ({
      // patient : null
    }),

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    computed: {
      vices_alert_message() { return this.$store.getters['patient/vices_alert_message'] },
      dietary_alert_message() { return this.$store.getters['patient/dietary_alert_message'] },
      immunization_alert_message() { return this.$store.getters['patient/immunization_alert_message'] },
      illnesses_alert_message() { return this.$store.getters['patient/illnesses_alert_message'] },
      hospitalizations_alert_message() { return this.$store.getters['patient/hospitalizations_alert_message'] },
      operations_alert_message() { return this.$store.getters['patient/operations_alert_message'] },

      isSeasonalIllness: {
        get() { return this.$store.getters['cases/isSeasonalIllness'] },
        set(val) { this.$store.commit('cases/updateIsSeasonalIllness', val) }
      },

      last_menstrual_period: {
        get() { return this.$store.getters['cases/last_menstrual_period'] },
        set(val) { this.$store.commit('cases/setLmp', val) }
      },

      loa() { return this.$store.getters['cases/loa'] },

      patient: {
        get() { return this.$store.getters['patient/patient'] },
        set(val) { this.$store.commit('patient/updatePatient', val) }
      },

      has_warning: {
        get() { return this.$store.getters['patient/has_warning'] },
        set(val) { this.$store.commit('patient/updateHasWarning', val) }
      },

      warning_reason: {
        get() { return this.$store.getters['patient/warning_reason'] },
        set(val) { this.$store.commit('patient/updateWarningReason', val) }
      },

      weight: {
        get() { return this.$store.getters['patient/weight'] },
        set(val) { this.$store.commit('patient/updateWeight', val) }
      },

      height: {
        get() { return this.$store.getters['patient/height'] },
        set(val) { this.$store.commit('patient/updateHeight', val) }
      },

      family_history: {
        get() { return this.$store.getters['patient/family_history'] },
        set(val) { this.$store.commit('patient/updateFamilyHistory', val) }
      },

      vices: {
        get() { return this.$store.getters['patient/vices'] },
        set(val) { this.$store.commit('patient/updateVices', val) }
      },

      dietary: {
        get() { return this.$store.getters['patient/dietary'] },
        set(val) { this.$store.commit('patient/updateDietary', val) }
      },

      immunization: {
        get() { return this.$store.getters['patient/immunization'] },
        set(val) { this.$store.commit('patient/updateImmunization', val) }
      },

      illnesses: {
        get() { return this.$store.getters['patient/illnesses'] },
        set(val) { this.$store.commit('patient/updateIllnesses', val) }
      },

      hospitalizations: {
        get() { return this.$store.getters['patient/hospitalizations'] },
        set(val) { this.$store.commit('patient/updateHospitalizations', val) }
      },

      operations: {
        get() { return this.$store.getters['patient/operations'] },
        set(val) { this.$store.commit('patient/updateOperations', val) }
      },
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    methods: {
      //
    },
    
    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    mounted() {
      /*console.log("Patient Data");
      console.log(this.patient);
      console.log(this.form);*/
    }
  }
</script>

<style lang="scss" scoped>
  span.alert {
    color: red;
    font-size: 13px;
    font-weight: bold;
  }
</style>